import * as React from "react";

import { getExtensionsDisplayForAssetTypes } from "@v2/features/assets/utils";
import { AnimatePresence, motion } from "motion/react";

type FileUploadOverlayProps = {
  isDragging: boolean;
  acceptedTypes: ("image" | "video")[] | null;
};

export const FileUploadOverlay: React.FC<FileUploadOverlayProps> = ({
  isDragging,
  acceptedTypes,
}) => {
  const hasInterceptor = acceptedTypes !== null;
  const assetTypeLabel =
    acceptedTypes?.length === 1 ? `${acceptedTypes[0]}s` : "files";
  const message = hasInterceptor
    ? `Drop ${assetTypeLabel} to upload to element`
    : "Drop files to attach to chat";

  const extensionsDisplay = getExtensionsDisplayForAssetTypes(acceptedTypes);

  return (
    <AnimatePresence>
      {isDragging && (
        <motion.div
          className="absolute inset-0 z-50 flex items-center justify-center pointer-events-none bg-black/5"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          aria-hidden
        >
          <div className="flex items-center gap-4 p-6 rounded-xl border-2 border-dashed border-border bg-white text-sm text-muted shadow-lg">
            <img
              src="/images/chat/files-graphic.svg"
              alt="File upload graphic"
              width={72}
              height={72}
            />
            <div>
              <div className="font-medium text-base mb-1">{message}</div>
              <div>{extensionsDisplay}</div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
